import { Routes } from '@angular/router';

export const routes: Routes = [
  { path: 'adopter', loadChildren: () => import('./buyer/buyer.module').then(m => m.BuyerModule) },
  { path: 'pet-giver', loadChildren: () => import('./seller/seller.module').then(m => m.SellerModule) },
  { path: 'auth', loadChildren: () => import('./authentication/authentication.module').then(m => m.AuthenticationModule) },
  {path: 'admin', loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)},
  // Pet Giver Registration Route (from email links)
  { path: 'register-pet-giver', redirectTo: '/pet-giver/register-as-pet-giver', pathMatch: 'full' },
  // Public check behind the verify link and QR code on adoption certificates
  { path: 'verify/:id', loadComponent: () => import('./common/verify-certificate/verify-certificate.component').then(m => m.VerifyCertificateComponent) },
  { path: '', loadChildren: () => import('./home/home.module').then(m => m.HomeModule)},
];

function isMobile(): boolean {
  return window.innerWidth <= 768;
}

